import React, { Component } from 'react';
import Slider from 'react-slick';

import { imgSrcAddPrefix } from '../utility/global'

export default class MainPicSlickWrap extends Component {
  render() {
    const {
      isShowResult,
      picItem,
      isGoToTheSamePosition,
      picIndex,
      // gotoRow,
      selectedState,
      isReset,
      updateSamePosition,
      excludeItemList,
    } = this.props;
    // slickSetting
    const settings = {
      className: "mainCenter",
      initialSlide: (
        isShowResult ?
        selectedState[picIndex].showIndex !== selectedState[picIndex].realJsonIndex ? selectedState[picIndex].realJsonIndex : selectedState[picIndex].showIndex
          // selectedState[picIndex].realJsonIndex
          :
          0
      ),
      centerMode: false,
      infinite: true,
      centerPadding: "100px",
      // slidesToShow 要 -1
      slidesToShow: 1,
      speed: 500,
      beforeChange: (current, next) => {
        this.setState({ oldSlide: current, activeSlide: next });
      },
      afterChange: current => {
        this.setState({ activeSlide: current })
        updateSamePosition(false)
      }
    };
    return (
      <Slider
        ref={MainPicSlider => (this.MainPicSlider = MainPicSlider)}
        {...settings}>
        {
          picItem.itemList.map((item, index) => {
            return (
              !(JSON.stringify(excludeItemList).indexOf(item.itype) === -1) ? null :
                <img
                  className="slickImg"
                  key={`${picItem.itemType}_${item.image}_${index}`}
                  src={imgSrcAddPrefix(item.image)} alt="" srcSet="" />
            )
          })
        }

        {
          isReset ?
            !this.MainPicSlider ? null :
              this.MainPicSlider.slickGoTo(0) : null
        }
        {
          // 這段是給 result 頁用的
          !isGoToTheSamePosition ? null :
            !selectedState ? null :
              !selectedState[picIndex] ? null :
                !this.MainPicSlider ? null :
                  this.MainPicSlider.slickGoTo(selectedState[picIndex].showIndex)
        }
      </Slider>
    )
  }
}
